import { render, staticRenderFns } from "./SocialJobDetails.vue?vue&type=template&id=01dcd978&scoped=true"
import script from "./SocialJobDetails.vue?vue&type=script&lang=js"
export * from "./SocialJobDetails.vue?vue&type=script&lang=js"
import style0 from "./SocialJobDetails.vue?vue&type=style&index=0&id=01dcd978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dcd978",
  null
  
)

export default component.exports